import * as Sentry from '@sentry/nextjs';

import { type HyperdxBaseConfig, setZettaClient } from '@zep/core-logger';
import { ZettaClient } from '@zep/zetta';

export { Sentry };

export const zettaClient = new ZettaClient();
setZettaClient(zettaClient);

export const hyperdxLoggerConfig: HyperdxBaseConfig = {
  service: 'auth-app',
  debug: false,
  consoleCapture: false,
  disableReplay: true,
};

if (typeof window !== 'undefined') {
  zettaClient.initialize();
}
